module.exports = __webpack_public_path__ + "media/images/bg_service_top_mv_sp-e3163cb9b66a008d1704e21771d2c518.jpg";